module.exports = __webpack_public_path__ + "js/0.8d1b24f3.worker.js"